module.exports = __webpack_public_path__ + "static/media/Asset.e39cdc5f.png";